import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { withStyles } from "material-ui";

import { Header, Footer, Sidebar } from "components";

import AddDappAlert from "views/Components/AddDappAlert.jsx";

import dashboardRoutes from "routes/dashboard.jsx";

import appStyle from "assets/jss/material-dashboard-react/appStyle.jsx";

//import image from "assets/img/sidebar-4.jpg";
//import image from "assets/img/sidebar-4.min.jpg";
//import image from "assets/img/consensys_58ca8c98b63ad.jpg";
import image from "assets/img/isp-blockchain-iot.jpg";


import logo from "assets/img/hexagon-dark.png";

const switchRoutes = (
<Switch>
    {dashboardRoutes.map((prop, key) => {
    if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.to} key={key} />;
    }
    if (prop.exact) {
        return <Route exact path={prop.path} component={prop.component} key={key} />;
    }
    return <Route path={prop.path} component={prop.component} key={key} />;
})}
  </Switch>
);



class App extends React.Component {
    state = {
        mobileOpen: false,
        addDappAlertShow: false,
    };
    addDapp() {
        this.setState({
            addDappAlertShow: true,
        });
    }
    addDappClose() {
        this.setState({
            addDappAlertShow: false,
        });
    }
    handleDrawerToggle = () => {
        this.setState({
            mobileOpen: !this.state.mobileOpen
        });
    };
    getRoute() {
        return this.props.location.pathname !== "/maps";
    }
    componentDidMount() {
        if (navigator.platform.indexOf('Win') > -1) {
            // eslint-disable-next-line
            const ps = new PerfectScrollbar(this.refs.mainPanel);
        }
        if (window.showAddDappAlert) {
            this.setState({
                addDappAlertShow: true,
            });
        }
    }
    componentDidUpdate() {
        this.refs.mainPanel.scrollTop = 0;
    }
    render() {
        let isMobile = false;
        if (window.matchMedia("(max-width: 700px)").matches) {
            isMobile = true;
        /* The viewport is less than, or equal to, 700 pixels wide */
        } else {
            isMobile = false;
        /* The viewport is greater than 700 pixels wide */
        }

        let style = {
            display: 'block',
            width: isMobile ? '3.2em' : '3.5em',
            height: isMobile ? '3.2em' : '3.5em',
            position: 'absolute',
            color: '#68b8e2',
            backgroundColor: 'white',
            borderRadius: '50%',
            zIndex: 999,
            right: isMobile ? '1.2em' : '3em',
            bottom: isMobile ? '3.5em' : '4em',
            border: '2px solid white',
        };

        const {classes, ...rest} = this.props;
        return (
            <div className={classes.wrapper}>
            { this.state.addDappAlertShow ? <AddDappAlert show={ this.state.addDappAlertShow } onClose={ () => this.addDappClose()} /> : null }
            <a href="https://t.me/joinchat/BPTgehJvvexlcffssOJxKQ" rel="noopener noreferrer" target="_blank">
            <svg style={style} aria-hidden="true" data-prefix="fab" data-icon="telegram" className="svg-inline--fa fa-telegram fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"></path></svg>
            </a>
        <Sidebar
            routes={dashboardRoutes}
            logoText={"ÐAppStore"}
            logo={logo}
            image={image}
            handleDrawerToggle={this.handleDrawerToggle}
            open={this.state.mobileOpen}
            color="blue"
            {...rest}
            />
        <div className={classes.mainPanel} ref="mainPanel" id="mainPanel">
          <Header
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            addDapp={ () => this.addDapp()}
            {...rest}
            />
          { /* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */ }
          {this.getRoute() ? (
                <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
                ) : (
                <div className={classes.map}>{switchRoutes}</div>
                )}
          {this.getRoute() ? <Footer addDapp={ () => this.addDapp()} /> : null}
        </div>
      </div>
        );
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(appStyle)(App);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx